document.addEventListener("DOMContentLoaded", () => {
  const menuButtons = document.querySelectorAll("#mobile-menu-button-template");
  if (!menuButtons.length) return;

  menuButtons.forEach((menuButton) => {
    const section =
      menuButton.closest(".shopify-section, [id^='shopify-section-']") || document;
    const header = section.querySelector(".header-revamp");
    const drawer = section.querySelector(".header-revamp-drawer");
    const cartCountEl = section.querySelector("#header-revamp-template-cart-count");
    const navLinks = section.querySelectorAll(".header-revamp-drawer-nav-link");
    const menuItems = section.querySelectorAll(".header-revamp-menu > ul > li");

    if (!drawer) return;

    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const threshold = 70;

    if (header) {
      window.addEventListener(
        "scroll",
        () => {
          const currentScrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

          if (
            currentScrollTop > threshold &&
            section instanceof HTMLElement
          ) {
            section.classList.toggle(
              "header-revamp-hidden",
              currentScrollTop > lastScrollTop
            );
          }

          lastScrollTop = Math.max(currentScrollTop, 0);
        },
        { passive: true }
      );

      drawer.style.height = `calc(100vh - ${header.offsetHeight}px)`;
      drawer.style.top = `${header.offsetHeight}px`;
    }

    function resetMobileNavToMain(noAnimation = false) {
      section.querySelectorAll(".hrmm-root").forEach((root) => {
        try {
          if (typeof root.resetHrmm === "function") {
            root.resetHrmm(noAnimation);
          } else {
            const active = root.querySelector(".hrmm-slide.active");
            const main = root.querySelector('.hrmm-slide[data-slide-id="main"]');
            if (active && main && active !== main) {
              active.classList.remove(
                "active",
                "enter-left",
                "enter-right",
                "exit-left",
                "exit-right"
              );
              main.classList.add("active");
            }
          }
        } catch (err) {
          console.warn("resetMobileNavToMain error", err);
        }
      });
    }

    menuButton.addEventListener("click", () => {
      const isNowOpen = drawer.classList.toggle("header-revamp-drawer-open");
      menuButton.classList.toggle("active");
      document.body.classList.toggle("no-scroll");

      if (!isNowOpen) {
        resetMobileNavToMain(true);
      }
    });

    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.attributeName === "class") {
          const isOpen = drawer.classList.contains("header-revamp-drawer-open");
          if (!isOpen) {
            resetMobileNavToMain(true);
          }
        }
      }
    });
    mo.observe(drawer, { attributes: true });

    menuItems.forEach((item) => {
      const block = item.querySelector(".header_revamp-mega-menu");
      if (!block) return;

      item.addEventListener("mouseenter", () => {
        block.style.height = `${block.scrollHeight}px`;
      });

      item.addEventListener("mouseleave", () => {
        block.style.height = `${block.scrollHeight}px`;
        requestAnimationFrame(() => {
          block.style.height = "0px";
        });
      });
    });

    navLinks.forEach((link) => {
      link.addEventListener("click", function () {
        const parentLi = this.closest("li");
        const submenu = this.nextElementSibling;
        if (!submenu?.classList.contains("header-revamp-drawer-nav-submenu")) {
          return;
        }

        parentLi.parentElement
          .querySelectorAll(".header-revamp-drawer-nav-submenu.active")
          .forEach((el) => {
            if (el !== submenu) el.classList.remove("active");
          });

        parentLi.parentElement.querySelectorAll("li.active").forEach((li) => {
          if (li !== parentLi) li.classList.remove("active");
        });

        submenu.classList.toggle("active");
        parentLi.classList.toggle("active");
      });
    });

    function updateCartCount(cart) {
      if (cartCountEl && cart?.item_count !== undefined) {
        cartCountEl.textContent = cart.item_count;
      }
    }

    document.addEventListener("rebuy:cart.ready", (e) =>
      updateCartCount(e.detail.cart)
    );
    document.addEventListener("rebuy:cart.change", (e) =>
      updateCartCount(e.detail.cart)
    );
  });
});
